import React, { useState, useEffect,useContext } from 'react';
import { useNavigate, useLocation  } from 'react-router-dom';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import Sidebar from './Sidebar';
import {apiUrl} from './UrlParam'; 
import AxiosFetchData from './AxiosFetchData';
import Notification from '../components/Notification'
import BackButton from '../components/BackButton'
import ResponseDialog from '../components/ResponseDialog';
import UserDialog from '../components/UserDialog';
//import socketIO from 'socket.io-client';
//import socket from '../hook/Socket.js'
import { Search, Bell, User, Menu } from 'lucide-react';
// import {messaging } from '../utils/firebase';
// import {onMessage} from "firebase/messaging"
const Header= ({message = null, setmessage = null, tipe = null,settipe=null, onMenuClick}) => {
  const [name, setName] = useState('');
  const [token, setToken] = useState('');
  const [expire, setExpire] = useState('');
  const Navigate = useNavigate();
  const location = useLocation();
  const [idStatus, setIdStatus] = useState('');
  const [open, setOpen] = useState(false);
  const [confirmStatusOpen, setConfirmStatusOpen] = useState(false);
  const [msg, setmsg] = useState(message);
  const [email, setEmail] = useState('');
   const [role, setRole] = useState('');
  //const socket = socketIO.connect(apiUrl);
 // const { socket, initializeSocket } = useContext(SocketContext);

  useEffect(() => {
    try{
      const decoded = jwt_decode(localStorage.getItem('token'));
      setName(decoded.name);
      setIdStatus(decoded.userID);
      setEmail(decoded.email)
      setRole(decoded.role)
        
      //initializeSocket()
    }catch(e){
     // Navigate('/')
    }
   
  }, []);
 
    const logout = async () => {
      const response = await axios.get(`${apiUrl}/logout/${email}`);
      if(response){
        setToken('');
        localStorage.clear();
     
        Navigate('/'); 
      }
    };

    function handleProfile(){
        setConfirmStatusOpen(true)
    }

     

  return (
    <>
    <header  className="bg-white border-b border-slate-200 sticky top-0 z-20">
      <div className="flex items-center justify-between px-8 py-4">
        <button
          onClick={onMenuClick}
          className="lg:hidden p-2 text-slate-600 hover:bg-slate-100 rounded-lg transition-colors"
        >
          <Menu className="w-5 h-5" />
        </button>
        <div className="flex-1 max-w-2xl">
            <div className="h-5 ml-5">
              <BackButton></BackButton>
          </div>
          {/* <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-5 h-5" />
            <input
              type="text"
              placeholder="Search anything..."
              className="w-full pl-10 pr-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all"
            />
          </div> */}
        </div>

        <div className="flex items-center space-x-4 ml-6">
          {/* <button className="relative p-2 text-slate-600 hover:bg-slate-100 rounded-lg transition-colors">
            <Bell className="w-5 h-5" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
          </button> */}
          <a href="#" onClick={logout} className='text-black'><i className="fa fa-sign-out"></i> Logout</a>
          <div className="flex items-center mt-4 space-x-3 pl-4 border-l border-slate-200">
            <div className="text-right">
               {role != "SL" && (
                <p>hi, <a onClick={handleProfile}><i></i> {name}</a></p>
              )}
      
              {role == "SL" && (
                  <p>Hi, <i></i> {name} </p>
              )}
              
            </div>
            
          </div>
        </div>
      </div>
    </header>
    
    {/* <header className="bg-[#71717B] border-b border-gray-200 px-4 py-5 ">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <button 
            onClick={onMenuClick}
            className="p-2 rounded-lg hover:bg-gray-100 lg:hidden"
          >
            <Menu size={20} />
          </button>
          
           <div className="h-5">
              <BackButton></BackButton>
          </div>
        </div>
       
        <div className="flex items-center gap-4">
          <button className="p-2 rounded-lg hover:bg-gray-100 sm:hidden hidden">
            
          </button>
          
          <button className="relative p-2 rounded-lg hover:bg-gray-100 hidden" >
            <Bell size={20} className="text-gray-600" />
            <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
              3
            </span>
          </button>
          
           <div className="flex items-center gap-3 pl-4 border-l border-gray-200">
            <div className="hidden sm:block text-right">
              <p className="text-sm font-medium text-gray-900">John Doe</p>
              <p className="text-xs text-gray-500">Administrator</p>
            </div>
            <div className="h-8 w-15 flex items-center justify-center">
           
              <a href="#" onClick={logout} className='text-white'><i className="fa fa-sign-out"></i> Logout</a>
            </div>
          </div>
        </div>
      </div>
    </header> */}
<Notification />
<ResponseDialog message={message ? message : msg} setmessage={message ? setmessage : setmsg} tipe={tipe} settipe={settipe}/>  
<UserDialog showDialog={confirmStatusOpen}
     handleClose={() => setConfirmStatusOpen(false)}
     idstatus ={idStatus}
     handleName={(username) => setName(username)}
     handleMessage={(msg) => setmsg(msg)}
    
      /> 
{/* 
  <Notification />
  <ResponseDialog message={message ? message : msg} setmessage={message ? setmessage : setmsg} tipe={tipe} settipe={settipe}/>  
  <section className="content-header">
   
    <ol className="breadcrumb">
    <div className='hi-users'><i className="fa fa-user-circle-o"></i>  Hi, <a className='link-hi' onClick={handleProfile}><i></i> {name}</a> </div>
    <div className='hi-logout'><a href="#" onClick={logout}><i className="fa fa-sign-out"></i> Logout</a></div>
    
    </ol>
    <div style={{textAlign:"left"}}> <BackButton/></div>
    <UserDialog showDialog={confirmStatusOpen}
     handleClose={() => setConfirmStatusOpen(false)}
     idstatus ={idStatus}
     handleName={(username) => setName(username)}
     handleMessage={(msg) => setmsg(msg)}
    
      /> 
  </section> */}

  </>
  );
};

export default Header;